import { render, staticRenderFns } from "./TestResultAction.vue?vue&type=template&id=7164afd3&scoped=true&"
import script from "./TestResultAction.vue?vue&type=script&lang=js&"
export * from "./TestResultAction.vue?vue&type=script&lang=js&"
import style0 from "./TestResultAction.vue?vue&type=style&index=0&id=7164afd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164afd3",
  null
  
)

export default component.exports